import {
  PROMOTION_STATUS_REQUEST,
  PROMOTION_STATUS_SUCCESS,
  PROMOTION_STATUS_FAILURE,
} from "../../actions/types";

// reducer.js
const initialState = {
  isLoading: false,
  response: null,
  error: null,
};

export const promotionStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROMOTION_STATUS_REQUEST:
      return { ...state, isLoading: true, response: null, error: null };
    case PROMOTION_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null,
      };
    case PROMOTION_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        response: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
